/**
 *
 * SummaryScreen
 *
 */

import React from "react"
import { List, Button } from "antd"
import { map, truncate, get } from "lodash"
import ModalCustom from "../ModalCustom"
import alertSvg from "../../images/alert.svg"
import "./index.less"
import { LeftOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import DOMPurify from "dompurify"

/* eslint-disable react/prefer-stateless-function */
class SummaryScreen extends React.Component {
  state = {
    modalBackOpen: false,
    modalImportAgainOpen: false,
    modalFinalize: false,
    count_again: 1,
  }

  fileSelectedHandler = (event) => {
    let { count_again } = this.state

    event.preventDefault()
    let fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    if (this.props.uploadWithId) {
      fd = { file: fd, id: this.props.id }
    }
    this.props.uploadTemplate(fd)
    this.fileInput.value = ""

    count_again++
    this.setState({ count_again })
  }

  saveOK = (confirm = false) => {
    if (
      !confirm &&
      this.props.measures_affected &&
      this.props.measures_affected.length > 0 &&
      this.props.type !== 'teams'
    ) {
      return this.setState({ modalFinalize: true })
    }
      

    const {
      count_import,
      count_update,
      count_error,
      checkSendInvitation,
    } = this.props
    const { count_again } = this.state
    const params = {
      count_import,
      count_update,
      count_error,
      attempts: count_again,
      send_invitation: checkSendInvitation,
    }
    this.props.onFinalize(params)
  }

  handleTextResume = (type = "success") => {
    const { textResume, count_import } = this.props
    if (!textResume) {
      return false
    }
    return textResume[type]
  }

  showSuccessCount() {
    if(this.props.type === "teams") {
      return `líderes importados`
    }

    if(this.props.type === "divisions-assignment") {
      return `divisiones asignadas`
    }

    if(this.props.title.toLowerCase().includes("cesados")) {
      return `colaboradores cesados`
    }
    
    return (
      `${
        this.props.typeImport
          ? `${this.props.typeImportText}${
              this.props.count_import > 1 ? "s" : ""
            }`
          : this.props.title
      } importada${this.props.count_import > 1 ? "s" : ""}`
    )
  }

  showFailedCount() {
    if(this.props.type === "teams") {
      return `líderes sin importar`
    }

    if(this.props.type === "divisions-assignment") {
      return `divisiones sin asignar`
    }

    if(this.props.title.toLowerCase().includes("cesados")) {
      return `colaboradores sin cesar`
    }
    
    return (
      `${
        this.props.typeImport
          ? `${this.props.typeImportText}${
              this.props.count_error != 1 ? "s" : ""
            }`
          : this.props.title
      } sin importar`
    )
  }

  showUpdateCount() {
    if(this.props.type === "teams") {
      return (
        <span style={{ marginLeft: 16 }} className="resumeUpdate">
          <span>{this.props.count_update} </span>
          líderes actualizados
        </span>
      )
    }
  }

  showDeleteCount() {
    if(this.props.type === "teams") {
      return (
          <span style={{ marginLeft: 16 }} className="resumeDelete">
            <span>{this.props.count_delete} </span>
            líderes eliminados
          </span>
        )
    }
  }

  showModalFinalizeContent(){

    if(this.props.modalFinalize === "teams") {
      return (
        <>
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            ¿Estás seguro que deseas importar los líderes?
          </span>
          <p style={{ fontSize: 13, marginTop: 8 }}>
            La acción <b>no será reversible</b>.
          </p>
        </>
      )
    }
    if(this.props.modalFinalize === "collaborators-cease") {
      return (
          <span>
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              ¿Estás seguro de que deseas eliminar a los colaboradores?
            </span>
    
            {this.props.measures_affected && (
              <p style={{ fontSize: 13, marginTop: 8 }}>
                Se <b>eliminarán</b> tambien sus respuestas en las mediciones
                que
                <br /> participaron, que aún no han sido oficializadas:
                <br />
                <br />
                {this.props.measures_affected.map((measure, index) => {
                  return (
                    <span key={index}>
                      {measure.name}
                      <br />
                    </span>
                  )
                })}
              </p>
            )}
    
            <p style={{ fontSize: 13, marginTop: 8 }}>
              La acción <b>no será reversible</b>.
            </p>
          </span>
      )
    }

    return this.props.modalFinalize
  }

  render() {
    const hasCompanyErrors = get(this.props, "company_errors", []).length > 0
    let modelType = this.props.model || ""
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <React.Fragment>
        <div className="summary-screen">
          <div className="summary-screen-header">
            <div className="summary-screen-btn-back">
              <span
                onClick={() => {
                  woopraTrack(
                    `Volver a ${this.props.backTitle || this.props.title}`
                  )
                  this.setState({ modalBackOpen: true })
                }}>
                <LeftOutlined /> {this.props.backTitle || this.props.title}
              </span>
            </div>
            {!this.props.hideHeader && (
              <React.Fragment>
                <div className="summary-screen-title">
                  {this.props.typeImport === "divisions-assignment" ? 'Asignación de divisiones' : `${this.props.typeImport || "Importación"} de ${this.props.title}`}
                </div>
                <div className="summary-screen-description">
                  Revisa si se ha producido algún error en la importación de la
                  información. De ser el caso, realiza las correcciones
                  necesarias y vuelve a importar el archivo.
                </div>
              </React.Fragment>
            )}
            {this.props.type === "teams" &&  
              <div style={{marginTop: 24, marginBottom: 8}}>
                <p style={{marginBottom: 12, fontWeight: 500, fontSize: 16}}>Importación de líderes</p>
                Revisa si se ha producido algún error en la importación de la información. De ser el caso, realiza las correcciones necesarias y vuelve a importar el archivo.
              </div>
            }
            <div className="summary-screen-summary-title">
              <>
                Resumen de importación{" "}
                {this.props.title.toLowerCase().includes("cesados") &&
                  "de cesados"}
              </>
            </div>
            <div className="summary-screen-info">
              {!hasCompanyErrors && (
                <span className="resumeSuccess">
                  {this.handleTextResume("success") ? (
                    this.handleTextResume("success")
                  ) : (
                    <React.Fragment>
                      <span>{this.props.count_import || 0} </span>
                      {this.showSuccessCount()}
                    </React.Fragment>
                  )}
                </span>
              )}

              {!hasCompanyErrors &&
                !this.props.title.toLowerCase().includes("cesados") &&
                this.props.hasUpdates && (
                  <span style={{ marginLeft: 16 }} className="resumeSuccess">
                    <span>{this.props.count_update} </span>
                    {this.props.typeImport
                      ? this.props.typeImportText
                      : this.props.title}{" "}
                    actualizados
                  </span>
                )}
              <span
                className="resumeFailed"
                style={{ marginLeft: hasCompanyErrors ? 0 : "" }}>
                {this.handleTextResume("failed") ? (
                  this.handleTextResume("failed")
                ) : (
                  <React.Fragment>
                    <span>{this.props.count_error || 0} </span>
                    {this.showFailedCount()}
                  </React.Fragment>
                )}
              </span>

              {this.showUpdateCount()}

              {this.showDeleteCount()}

            </div>
            <p style={{ marginBottom: 0, color: "#4F4F4F" }}>
              A continuación se presentan los{" "}
              <span style={{ fontWeight: 600 }}>motivos de error </span>
              en la importación
              {this.props.title.toLowerCase().includes("cesados") &&
                " de cesados"}
              :
            </p>
          </div>
          <div className="summary-screen-body">
            {hasCompanyErrors ? (
              <List
                className="summary-screen-list"
                size="large"
                locale={{ emptyText: "No hay errores para mostrar" }}
                bordered
                dataSource={this.props.company_errors}
                renderItem={(item) => {
                  const sanitizedHTML = DOMPurify.sanitize(item);
                  return (
                    <List.Item>
                      <div className="ant-list-item-content-div">
                        <span dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
                      </div>
                    </List.Item>
                  )
                }}
              />
            ) : (
              <List
                className="summary-screen-list"
                style={{ maxWidth: this.props.maxWidthTable }}
                size="large"
                locale={{ emptyText: "No hay errores para mostrar" }}
                header={
                  <div
                    className="ant-list-header-div"
                    style={{ gridTemplateColumns: this.props.gridHeader }}>
                    {map(this.props.header, (content, index) => {
                      return <span key={index}>{content}</span>
                    })}
                  </div>
                }
                bordered
                dataSource={this.props.listErrors}
                renderItem={(item) => {
                  return (
                    <List.Item>
                      <div
                        className="ant-list-item-content-div"
                        style={{ gridTemplateColumns: this.props.gridContent }}>
                        {map(this.props.content, (content, index) => {
                          if (content === "lastName" && item.secondLastName) {
                            return (
                              <span
                                key={
                                  index
                                }>{`${item.lastName} ${item.secondLastName}`}</span>
                            )
                          }

                          if (
                            this.props.title
                              .toLowerCase()
                              .includes("cesados") &&
                            content === "document"
                          ) {
                            return (
                              <span key={index}>
                                {truncate(item[content], { length: 16 })}
                              </span>
                            )
                          }

                          return <span key={index}>{item[content]}</span>
                        })}
                      </div>
                    </List.Item>
                  )
                }}
              />
            )}

            <div className= {`summary-screen-buttons ${hasFreshchat ? "buttonsFooterMargin" : ""}`} >
              <Button
                onClick={() => {
                  woopraTrack(`Reintentar Importar ${modelType}`)
                  this.setState({ modalImportAgainOpen: true })
                }}
                style={{ boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.15)" }}
                type="ghost">
                Reintentar
              </Button>
              {!hasCompanyErrors && (
                <Button
                  type="primary"
                  onClick={() => {
                    woopraTrack(`Finalizar Importar ${modelType}`)
                    if(this.props.modalFinalize) {
                      return this.setState({ modalFinalize: true })
                    } else {
                      this.saveOK()
                    }
                  }}>
                  Finalizar
                </Button>
              )}
            </div>
          </div>
        </div>

        <ModalCustom
          action={`Volver a ${this.props.backTitle || this.props.title}`}
          modalOpen={this.state.modalBackOpen}
          showFooter
          onOk={() =>
            this.props.urlBackH
              ? this.props.urlBack()
              : this.props.history.push(this.props.urlBack || "/organization")
          }
          onCancel={() => this.setState({ modalBackOpen: false })}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            {this.props.backModalTitle ||
              "¿Estás seguro de que deseas salir de la importación?"}
          </span>
          <p style={{ fontSize: 13, marginTop: 8 }}>
            La información no será registrada y deberás iniciar un nuevo proceso
            de importación.
          </p>
        </ModalCustom>

        <ModalCustom
          modalOpen={this.state.modalImportAgainOpen}
          action={this.props.action}
          showFooter
          onOk={() => {
            this.setState({ modalImportAgainOpen: false }, () => {
              this.fileInput.click()
            })
          }}
          onCancel={() => this.setState({ modalImportAgainOpen: false })}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            {this.props.modalImportAgainTitle ||
              "¿Estás seguro de que deseas realizar una nueva importación?"}
          </span>
          <p style={{ fontSize: 13, marginTop: 8 }}>
            La información no será registrada y deberás iniciar un nuevo proceso
            de importación.
          </p>
        </ModalCustom>
        <input
          style={{ display: "none" }}
          type="file"
          onChange={this.fileSelectedHandler}
          ref={(fileInput) => (this.fileInput = fileInput)}
        />

        <ModalCustom
          action={this.props.action}
          modalOpen={this.state.modalFinalize}
          textButton="Eliminar"
         /*  colorButton="#2694FC" */
          onOkId="btnFinalizar"
          showFooter
          onOk={() => {
            this.setState({ modalFinalize: false })
            this.saveOK(true)
          }}
          onCancel={() => this.setState({ modalFinalize: false })}
          textButton="Finalizar"
          disabledButton={this.props.disabledButton()}
          width={this.props.modalFinalizeWidth}>
          <img src={alertSvg} className="alertIcon" />
          {this.props.modalFinalize && this.showModalFinalizeContent()}
        </ModalCustom>
      </React.Fragment>
    )
  }
}

SummaryScreen.propTypes = {}

export default SummaryScreen
